import React from "react";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button} from 'react-admin';
import {messageTopolSaving} from '../../actions/messageActions';
import {selectIsMessageSaving} from "../../selectors/messageSelectors";
import SaveIcon from '@material-ui/icons/Save';

const StructuredMessageSaveButton = ({action, label, saving, save, style = {}}) => (
    <Button
        label={label}
        onClick={() => save(action)}
        disabled={saving}
        style={style}
        variant={'raised'}
    >
        <SaveIcon/>
    </Button>
);

StructuredMessageSaveButton.propTypes = {
    action: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    save: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired,
    style: PropTypes.object,
};

const mapStateToProps = (state) => ({
    saving: selectIsMessageSaving(state),
});

const mapDispatchToProps = (dispatch) => ({
    save: (redirect) => dispatch(messageTopolSaving(redirect)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StructuredMessageSaveButton);
